import {mapValues} from 'lodash'
import {animatedPage} from '../../components/page'
import Groups from './groups' 

const pages = mapValues({
  "groups": Groups
}, animatedPage)

export default pages
